'use strict';
define(['./../Authentication', './Level2', '../../data/config/app' ], function (Authentication, Level2, config) {

    function Navigation() {
        var auth = new Authentication();
        new Level2(config, auth);
    }
    return Navigation;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/Index.js